import { useEffect, useReducer } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TimeAward from './../../../../commons/components/Award/TimeAward'
import ROUTERS from '../../../../commons/constans/router';
import { convertUrlTObject, priceFormat, sharekakaoApi, shareKakaoTalk } from "../../../../utils/helpers";
import DialogComponent from "./../../../../commons/components/Modal/DialogComponent";
import { SEASON_IMG } from "../../../../commons/constans/seasonImg";

type props = {};

const AwardsProgressComponent = ({entry = {}, award = {}, onDelete}: props) => {
  const [confirmModal, setConfirmModal] = useReducer(p => !p, false)
  const location = useLocation();
  const shareKakao = () => {
    console.log(award, 'award');
    let pathName = `award/voting?id=${entry.id}`;
    let linkRedirect =  `${process.env.REACT_APP_URL}/award/voting?id=${entry.id}`;
    let season = ['SUMMER', 'AUTUMN', 'SPRING', 'WINTER', 'FALL'];
    let seasonLabel = award.season_label;
    // const intersection = season.filter(element => arr.includes(element));
    let thumbnail;
    switch (seasonLabel) {
      case 'SPRING':
        console.log('SPRING');
        thumbnail = SEASON_IMG.SPRING
        break;
      case 'SUMMER':
        console.log('SUMMER');
        thumbnail = SEASON_IMG.SUMMER
        break;
      case 'AUTUMN':
        console.log('AUTUMN');
        thumbnail = SEASON_IMG.AUTUMN
        break;
      case 'FALL':
        console.log('FALL');
        thumbnail = SEASON_IMG.AUTUMN
        break;
      case 'WINTER':
        console.log('WINTER');
        thumbnail = SEASON_IMG.WINTER
        break;
      default:
        break;
    }

    //share AWARD_PHOTO
    let data = {
      obj_id: entry.id || '',
      obj_type: 'AWARD_PHOTO',
      channel: 'KAKAO'
    }
    sharekakaoApi(data);
    
    shareKakaoTalk('Sphokidz', `촬영한 사진으로 스포키즈 포토 어워즈에 참여해보세요`, thumbnail || '', thumbnail || '', pathName, linkRedirect);
  }

  const _handleSubmit = () => {
    if (onDelete) {
      onDelete()
    }
    
    // handleSubmit({
    //   children_id: formData.children_id,
    //   photo_id: formData.photo_id,
    //   contact_phone: (formData.contact_phone ?? '').replaceAll('-','')
    // })
    setConfirmModal()
  }

  if (entry.deleted_at) {
    return null
  }

  return (
    <div className="awards-top-ten awards-my-rank pb-0">
      <div className="awards-top-ten__my-rank mb-0">
        <div className="content-my-rank">
          <div className="content-my-rank__title">
            <h3>나의 랭킹은?</h3>
          </div>
          <div className="content-my-rank__info-user">
            <img
              className="content-my-rank__info-user__avatar"
              src={entry.photo?.photo_url?.thumbnail}
              alt={entry?.user?.nickname}
            />
            <label className="content-my-rank__info-user__name text-truncate">
              {entry?.user?.nickname}
            </label>
            <div className="content-my-rank__info-user__ranking-vote">
              <div className="info-user__item info-user__ranking">
                <label className="info-user__item__value">
                  {priceFormat(entry.rank)}위
                </label>
                <div className="info-user__item__title">
                  <img className="info-user__item__title__icon" src="/images/icon_myrank.svg" />
                  <label className="info-user__item__title__text">현재 나의 순위</label>
                </div>
                {!entry.deleted_at && <button
                  type="button"
                  className="btn info-user__item__btn info-user__item__btn-share"
                  onClick={shareKakao}>
                  공유하기
                </button>}
              </div>
              <div className="info-user__item info-user__vote">
                <label className="info-user__item__value">
                  {priceFormat(entry?.total_vote ?? 0)}표
                </label>
                <div className="info-user__item__title">
                  <img className="info-user__item__title__icon" src="/images/icon_myvote.svg" />
                  <label className="info-user__item__title__text">총 득표수</label>
                </div>
                {!entry.deleted_at && <button
                  type="button"
                  className="btn info-user__item__btn info-user__item__btn-cancel"
                  onClick={setConfirmModal}>
                  참여등록취소
                </button>}
              </div>
            </div>
          </div>
        </div>
      </div>

      <DialogComponent
        id={"MD4"}
        show={confirmModal}
        title={'알림'}
        closeBtn={"취소"}
        customBtn={"확인"}
        handleClose={setConfirmModal}
        handleCustom={_handleSubmit}
      >
        참여등록을 취소하시겠습니까? <br />
        해당 분기에 재등록은 불가능합니다. <br />
        <small className="text-danger word-break-keep">
          확인을 누르면 참여등록이 취소되며 <br />
          지급 포인트가 차감됩니다.
        </small>
      </DialogComponent>
    </div>
  );
};

export default AwardsProgressComponent;
